// Temporary frontend catalog for permission keys and roles
// If backend catalogs become available, switch to fetching them.

export const PERMISSION_KEYS = [
    // Base resource-scoped keys
    { key: 'report.view', label: 'Просмотр отчётов ресурса' },
    { key: 'permissions.manage', label: 'Управление доступами на ресурс' },
    { key: 'settings.view', label: 'Просмотр настроек ресурса' },
    { key: 'settings.edit', label: 'Редактирование настроек ресурса' },

    // Webapp management keys (user/app controller)
    { key: 'webapp.view', label: 'Веб-приложения: просмотр' },
    { key: 'webapp.manage', label: 'Веб-приложения: управление' },

    // Custom fields
    { key: 'custom_fields.view', label: 'Произвольные поля: просмотр' },
    { key: 'custom_fields.manage', label: 'Произвольные поля: управление' },

    // Storage
    { key: 'storage.upload', label: 'Хранилище: загрузка файла' },

    // Integrations
    { key: 'integrations.view', label: 'Интеграции: просмотр' },
    { key: 'integrations.manage', label: 'Интеграции: управление' },

    // Communication module keys
    { key: 'communication.users.list', label: 'Коммуникации: список пользователей' },
    { key: 'communication.chat.view', label: 'Коммуникации: просмотр чата пользователя' },
    { key: 'communication.files.get', label: 'Коммуникации: получение файлов' },
    { key: 'communication.messages.send', label: 'Коммуникации: отправка сообщений' },

    // Заявки на вступление в закрытый канал/группу
    { key: 'join_requests.view', label: 'Заявки на вступление: просмотр' },
    { key: 'join_requests.manage', label: 'Заявки на вступление: одобрение и отклонение' },

    // User module keys
    { key: 'errors.view', label: 'Ошибки: просмотр' },
    { key: 'secure.manage', label: 'Токен бота: управление (подключение/отключение), webhook и способ доставки' },
    { key: 'referral.payouts.manage', label: 'Реф. программа: управление выплатами' },
    { key: 'convers.view', label: 'Диалоги: просмотр' },
    { key: 'convers.manage', label: 'Диалоги: управление' },

    // Tasker module keys
    { key: 'tasker.task.create', label: 'Рассылки: создание' },
    { key: 'tasker.task.view', label: 'Рассылки: просмотр' },
    { key: 'tasker.task.update', label: 'Рассылки: редактирование' },
    { key: 'tasker.run_test', label: 'Рассылки: тестовый запуск' },
    { key: 'tasker.campaign.run', label: 'Рассылки: запуск кампании' },
    { key: 'tasker.campaign.stop', label: 'Рассылки: остановка кампании' },
    { key: 'tasker.list.save', label: 'Сегменты: сохранить список' },
    { key: 'tasker.list.delete', label: 'Сегменты: удалить список' },
    { key: 'tasker.users.list', label: 'Рассылки: список доступных пользователей' },

    // Workflows (Automation) module
    { key: 'workflows.view', label: 'Автоматизация: просмотр' },
    { key: 'workflows.manage', label: 'Автоматизация: управление' },

    // Cohorts
    { key: 'cohorts.view', label: 'Когорты: просмотр' },

    // Database module (raw events/messages tables)
    { key: 'database.view', label: 'База данных: просмотр сырых событий и сообщений' },
    { key: 'database.manage', label: 'База данных: создание типов событий' },

    // AI assistant
    { key: 'ai_assistant.use', label: 'AI-ассистент: использование (расход токенов проекта)' },

    // Project-scoped only — see ProjectPermissions.vue / the add-resource wizard's "add to project" step.
    { key: 'resource.add', label: 'Добавление ресурса' },
];

export const ROLES = [
  {
    key: 'viewer',
    label: 'Viewer',
    description: 'Can view reports only',
    perm_keys: ['report.view']
  },
  {
    key: 'analyst',
    label: 'Analyst',
    description: 'Can view reports and users section',
    perm_keys: ['report.view', 'communication.users.list', 'settings.view']
  },
  {
    key: 'manager',
    label: 'Manager',
    description: 'Full management access',
    perm_keys: ['report.view', 'communication.users.list', 'settings.view', 'settings.edit', 'permissions.manage', 'integrations.view', 'integrations.manage']
  }
];

export function getPermissionKeyLabel(key) {
  return PERMISSION_KEYS.find(k => k.key === key)?.label || key;
}

export function getRoleLabel(key) {
  return ROLES.find(r => r.key === key)?.label || key;
}
